<template>
  <div>
    <div v-if="$root.unsupported">Unfortunately this browser is not supported, please use a more recent version</div>
    <splash v-if="!$root.unsupported" delay="20000">
        <pa-header name="home" title="Podere Ampella" :sections="['Villas', 'Activities', 'Testimonials', ' Location', 'Contact Us']" @onGotoSection="gotoSection">
        </pa-header>
    
        <modal></modal>

        <top-banner>Luxury 2 and 3 bedroom villas from
          <span class='standout'>€{{fromPrice}}</span>
        </top-banner>
    
        <slider auto :delay="3" kenburns random :imagelist="[
          { img: require('./assets/__7444.jpg'), caption: '' },
          { img: require('./assets/__8282.jpg'), caption: '' },
          { img: require('./assets/__8285.jpg'), caption: '' },
          { img: require('./assets/__8218.jpg'), caption: '' },
          { img: require('./assets/__8679.jpg'), caption: '' },
          { img: require('./assets/__9435.jpg'), caption: '' },
          { img: require('./assets/__9999.jpg'), caption: '' },
          { img: require('./assets/__4839.jpg'), caption: '' },
          { img: require('./assets/__4953.jpg'), caption: '' },
          { img: require('./assets/__2222.jpg'), caption: '' },
          { img: require('./assets/__2051.jpg'), caption: '' },
          { img: require('./assets/__2105.jpg'), caption: '' },
          { img: require('./assets/__4019.jpg'), caption: '' },
          { img: require('./assets/__2164.jpg'), caption: '' },
          { img: require('./assets/__1576.jpg'), caption: '' },
          { img: require('./assets/__9107.jpg'), caption: '' },
          { img: require('./assets/__3156.jpg'), caption: '' },
          { img: require('./assets/__1001.jpg'), caption: '' }]"></slider>
    
        <text-Section serif>
          <h1>Welcome to Podere Ampella, a beautiful location in Tuscany</h1>
          Live the relaxed Tuscan lifestyle in the idyllic setting of this unique hilltop Borgo. The hamlet is centred in the most sought after location in Tuscany, overlooking the renowned Val d'Orcia landscape. With convenient access to some of the world’s most
          famous towns and cities, steeped in art, history and culture.
        </text-section>
    
        <single-picture-section orientation="left" :img='require("./assets/__4953.jpg")'>
          A truly unique experience, Podere Ampella offers a limited number of select two &amp; three bedroom villas and town houses meticulously reconstructed to the highest specification. The beautiful interiors combine traditional architecture with stylish contemporary
          living and are surrounded by private gardens, pergolas, courtyards and pools.
        </single-picture-section>
    
        <single-picture-section :img='require("./assets/__2222.jpg")' orientation="right">
          The hamlet is centred in the most sought after location in Tuscany overlooking the renowned Val d'Orcia landscape. With ease of access to some of the world’s most famous towns and cities, steeped in art, history and culture. Podere Ampella makes for a
          truly unique experience.
        </single-picture-section>
    
        <section-head text='Villas' linkname='villas'></section-head>
    
        <text-section class='textcentered'>
          We have 9 stunning villas available. All the villas have Wifi access, a washing machine, dishwasher, air-conditioning and parking. All have access to a shared pool, and Villa Montisi also has a private pool.
        </text-section>
    
        <VillaBoxes :villas='$root.villas'></VillaBoxes>
    
        <section-head text='Activities' linkname='activities'></section-head>
    
        <CardSection>
          <Card :img='require("./assets/__balloons.jpg")' title='Hot Air Ballooning'>
            Gaze over the Val D’orcia and Crete Senese from above. Start off early in the morning and enjoy the sunrise whilst drifting over the countryside, wherever the wind takes you. Finish with a mid morning superb champagne breakfast upon landing.
          </Card>
          <Card :img='require("./assets/__biking.jpg")' title='Mountain Biking'>
            We have a contact with an experience Mountain Bike Guide, who can take you for an amazing ride through the Orcia Valley. Be warned – there are lots of hills! All levels of experience catered for.
          </Card>
          <Card :img='require("./assets/__cooking.jpg")' title='Cookery Lessons'>
            We can put you in contact with Taste Tuscany who organise Cooking Lessons. Learn to make typical delicious Tuscan recipes in the ambience of a Tuscan country house. Hand on practical lessons including how to make home-made pasta, followed by a relaxed
            lunch.
          </Card>
          <Card :img='require("./assets/__horse.jpg")' title='Horse Riding'>
            Spend a half or full day meandering the hills of the Val D’Orcia with an experienced guide and trained horses. All levels of equestrian rider are catered for. Lessons are also available.
          </Card>
          <Card :img='require("./assets/__wine-tasting.jpg")' title='Wine Tasting'>
            This area is famous for its red wine, Rosso &amp; Brunello di Montalcino, Nobile di Montepulciano and Chianti. We can organise a Half Day or Full day Tour, including lunch in a vineyard, with the chance to see how the wines are made and to taste a selection
            of wonderful wines.
          </Card>
        </CardSection>
    
        <section-head text='Testimonials' linkname='testimonials'></section-head>
    
        <testimonial-section>
          <CardSection>
            <Card :img='require("./assets/booking-com.png")' title='Thank You!'>
            </Card>
          </CardSection>

          <testimonial when='Aprile 2018'>
            Tutto perfetto, l'appartamento era spazioso, pulito e confortevole ma soprattutto su una posizione eccezionale, tra le colline con una vista mozzafiato
          </testimonial>
          <testimonial when='July 2017'>
            We spent three weeks at Podere Ampella in a spacious, comfortable 2BR/2BA house. It was one of five on the property and was very quiet and private......With summer temperatures during our stay in the high nineties and over 100F, the very large and cool
            water of the pool was wonderful. This property is in San Giovanni D'asso, one of five mountain top villages. There were at least a half a dozen small towns and mideval villages near by, making daily outings easy and a real treat. The owner, Paola
            and her husband, and staff, Laura and Victor did everything they could to make our stay pleasurable. We recommend this property for a fun vacation.
          </testimonial>
          <testimonial when='July 2017'>
            We enjoyed staying at Casa di Sopra and can highly recommend this to others, too. We especially enjoyed the view from the house, the peace and the surroundings. Even it was hot we never needed the aircon on, as we could open windows during the evening
            and night. The only noise was from sheep at a nearby farm.
            <br/>Thank you for a wonderful stay. We appreciated being met by Paola, she was just great and easy to talk to. She was keen on making it a nice holiday for everybody
          </testimonial>
          <testimonial when='Giugno 2017'>
            Un posto incantevole sulle colline senesi; il sito è davvero ben tenuto, curato in ogni dettaglio, così come gli appartamenti e l'organizzazione. La piscina è davvero indimenticabile. Posto ideale per stare anche con i bambini in piena sicurezza.
          </testimonial>
          <testimonial when='June 2017'>Nous avons passé un excellent séjour à Podere Ampella. La villa est charmante et a répondu à toutes nos attentes. Elle est en outre idéalement située pour admirer les coucher de soleil. Nous avons également beaucoup apprécié la disponibilité de
            Paola. Nous recommandons!
          </testimonial>
          <testimonial when='June 2017'>We stayed for one week at this lovely stone cottage (casa beppe) and had a wonderful time. The cottage was clean and comfortable, and was well-equipped with everything that was needed for four people. A dip in the pool in the afternoon was very
            refreshing after visiting the many charming villages of the region. Paola and Laura were both lovely and very accommodating. I would recommend this villa to anyone who would like a relaxing place to stay while visiting the beautiful Tuscan countryside.
          </testimonial>
          <testimonial when='May 2017'>Two retired couples, seeking to explore Tuscany, rented this villa for a week. The villa is centrally located, making our daily excursions easy. The property is situated on top of a hill, surrounded by beautiful vistas. It's peaceful, rural setting
            suited us perfectly, yet we were only minutes from San Giovanni d'Asso, a small medieval village in which to buy groceries, have lunch or enjoy a coffee or glass of wine at the cafe. The villa itself, with two bedrooms and two baths, was perfect
            for two couples. The downstairs living room, dining room and kitchen were ideal for our stay-in evenings after our days of exploring. It was a comfortable and welcoming place to come home to each evening. Paola and Laura were exceptional hosts,
            especially when one of our group lost her passport and they facilitated it's recovery! They went way beyond what was expected. We loved our week in Tuscany, an experience enhanced by this lovely villa. We would stay there again without hesitation.
            <br/>Lorraine
          </testimonial>
          <testimonial when='June 2014'>We stayed for one week in casa Beppe and our friends at casa Marta. Both of houses have a fantastic views. We were lucky with weather for first days, children and we too, really enjoyed the pool. Houses are simply but nicely furnished. Bring your
            soap and you have to buy toilet paper, salt, sugar,pepper.. Te owner Paola is really nice and friendly, all booking process from beginning was very easy, I get always very quick reply for all my questions. Paola even call me at arrival day in
            the morning to confirm our arrival time. We haven't visited this time Siena or Florence. This time we visited Montalcino (15 min drive), Montepulciano, Castiglione del Lago, Pienza and design outlet the Mall (1h15 m. drive), you will find there
            Gucci, Prada, Tod's and many others brands. A shop in San Giovanni is small, in Sinalunga is much better choose. Thank you and best regards from Finland, Helsinki; Olga, Janne, Liisi, Peppiina, Isra, Mervi, Jurkki, Simo, Ismo
          </testimonial>
          <testimonial when='May 2012'>We had an amazing week. As we were driving there, we turned a corner along the road somewhere after Sinalunga and the scenery took our breath away. Every hillside seemed to grow in beauty and our anticipation increased as we neared Podere Ampella
            and it more than met our expectations. That first evening, as we sat outside in the peaceful garden, a small bat was flying around overhead and the sun was setting towards San Giovanni D'Asso, and we relaxed for the first time in a long time.
            The week was wonderful. The house had everything we needed and more. We were really impressed with how beautifully finished the rooms were. We travelled to many of the surrounding villages and ate some incredible food (I'm still dreaming of a
            restaurant we visited in Montalcino--the pasta with truffle sauce was unlike anything I've tasted before). But now of course normal life resumes and we're back to working long hours. Thank you for all your help! Best wishes, Andrea, Holland
          </testimonial>
          <testimonial when='June 2011'>I would like to say that we enjoyed a wonderful week at Podere Ampella. We would highly recommend it to anybody we know wishing to spend a holiday in beautiful peaceful surroundings. We cannot speak highly enough of the condition of the house, it
            was so clean and comfortable to stay in, we will definitely be back. G. McCann, Canada
          </testimonial>
        </testimonial-section>
    
        <section-head text='Location' linkname='location'></section-head>
        <text-section style='align-items: center'>
          <div>
            Only minutes away from:
            <div>
              Montalcino, Pienza, Rapolano Terme, Montisi, Monteriggioni, Montepulciano, San Quirico d'Orcia, Buonconvento
            </div>
          </div>
        </text-section>
    
        <text-section style='align-items: center'>
          <div style='width: 100%;text-align: center'>
            <img style='width:90%; border: solid 1px black' :src='require("./assets/map.jpg")' />
          </div>
        </text-section>
    
        <text-section style='align-items: center' serif>
          <div>Directions</div>
          <ul>
            <li>Take Motorway (green sign) A1 and exit at Valdichiana Bettolle.</li>
            <li>Take the freeway Siena Bettolle E78 in direction of Siena.</li>
            <li>Exit at Sinalunga and follow for Trequanda</li>
            <li>Once you reach the village of Trequanda follow for Montisi</li>
            <li>Drive through the village of Montisi and take the SP 14 in direction of San Giovanni d'Asso</li>
            <li>After about 4 km on your right (2 km before reaching San Giovanni d'Asso) you will find Podere Ampella</li>
          </ul>
          <p>GPS COORDINATE N 43 09’01.67 E 11 36’40.27</p>
        </text-section>
    
        <section-head text='Contact Us' linkname='contactus'></section-head>
        <text-section serif centered>
          Please feel free to contact <b>Paola</b> for any further queries or if you wish to book any of the villas
        </text-section>
    
        <contact-section>
          <contact-item :iconname='faEnvelope' bg='#0096dc' text='Email' href='mailto:podereampella1@gmail.com' link='podereampella1@gmail.com'></contact-item>
          <contact-item :iconname='faPhone' bg='green' text='Tel/Whatsapp' href='tel:+39 331 832 1009' link='+39 331 832 1009'></contact-item>
        </contact-section>
    
        <pa-footer/>
    </splash>
  </div>
</template>

<script>
// import axios from 'axios'

import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import faPhone from '@fortawesome/fontawesome-free-solid/faPhone'
import faUserFriends from '@fortawesome/fontawesome-free-solid/faUserFriends'
import faQuoteLeft from '@fortawesome/fontawesome-free-solid/faQuoteLeft'
import faBars from '@fortawesome/fontawesome-free-solid/faBars'
import faBath from '@fortawesome/fontawesome-free-solid/faBath'
import faEnvelope from '@fortawesome/fontawesome-free-solid/faEnvelope'
import faSpinner from '@fortawesome/fontawesome-free-solid/faSpinner'

import Splash from './components/Splash'
import Header from './components/Header'
import Modal from './components/Modal'
import TopBanner from './components/TopBanner'
import Slider from './components/Slider'
import TextSection from './components/TextSection'
import SinglePictureSection from './components/SinglePictureSection'
import SectionHead from './components/SectionHead'
import VillaBoxes from './components/VillaBoxes'
import VillaBox from './components/VillaBox'
import Card from './components/Card'
import CardSection from './components/CardSection'
import Testimonial from './components/Testimonial'
import TestimonialSection from './components/TestimonialSection'
import ContactItem from './components/ContactItem'
import ContactSection from './components/ContactSection'
import Footer from './components/Footer'


const DEFAULT_FROM_PRICE = 695

export default {
  name: 'App',
  data () {
    return {
      faPhone,
      faUserFriends,
      faQuoteLeft,
      faBars,
      faBath,
      faEnvelope,
      faSpinner,
      fromPrice: DEFAULT_FROM_PRICE,
      initialAnimation: false
    }
  },
  methods: {
    gotoSection (name) {
      const el = document.querySelector(`[name='${name}']`)
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  },
  mounted () {
    this.fromPrice = DEFAULT_FROM_PRICE;
    // axios
    //   .get('/api/cfg')
    //   .then((cfg) => { this.fromPrice = cfg.data['from-price'] || DEFAULT_FROM_PRICE })
    //   .catch(error => console.log(`could not retrieve config info, using defaults ${error}`))
  },
  components: {
    FontAwesomeIcon,
    Splash,
    'pa-header': Header,
    Modal,
    TopBanner,
    Slider,
    TextSection,
    VillaBoxes,
    SectionHead,
    SinglePictureSection,
    VillaBox,
    CardSection,
    Card,
    TestimonialSection,
    Testimonial,
    ContactItem,
    ContactSection,
    'pa-footer': Footer
  }
}
</script>

<style lang="less" scoped>
@import "./css/globals.less";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1 {
  font-weight: normal;
  font-size: @cursive-caption-font-size * 1.25;
  font-family: @cursive-font;
}

@keyframes bounce {
  0% {
    transform: scale(1);
    opacity: 0;
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.fade {
  transition: opacity 1s 0;
}

.loading-window {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #e4ab8b;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 1s linear;
}

.loading-window div {
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-title {
  animation: bounce 1.3s;
  font-size: 50pt;
  text-align: center;
}

.initial {
  opacity: 0;
  transition: 0;
}

.opaque {
  opacity: 1;
}

.transparent {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue